import { palette } from "../../../palette";
import { theme } from '../../theme';

const styles = {
    orderContainer: {
        backgroundColor: palette.primary.light,
        padding: '12px 16px 16px',
        position: 'relative',
        margin: '0 0 8px 0',
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: 8,
    },
    sectionTitle: {
        color: palette.primary.main,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 1.2,
        textTransform: 'uppercase',
        marginBottom: 10,
    },
    orderDetailsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
    },
    orderDetailsTitle: {
        color: palette.primary.main,
        textTransform: 'uppercase',
        fontWeight: 'bold',
    },
    // For ReturnTripDetailsBox
    returnTripContainer: {
        backgroundColor: '#f5f9ff',
        padding: '15px',
        position: 'relative',
        margin: '15px 0 5px 0',
        width:'100%',
        border: '1px solid #e0e9f7',
        borderRadius: '8px'
    },
    returnTripHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px'
    },
    returnTripIcon: {
        color: palette.primary.main,
        marginRight: '10px'
    },
    returnTripTitle: {
        color: palette.primary.main,
        fontWeight: 'bold',
        fontSize: theme.sizes.large,
        textTransform: 'uppercase'
    },
    packageCard: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fff',
        border: `1px solid ${palette.primary.light}`,
        borderRadius: 8,
        padding: '10px 16px',
    },
    packageImageBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: 64,
    },
    packageImage: {
        width: 44,
        height: 44,
        objectFit: 'contain',
    },
    packageSizeLabel: {
        fontSize: 11,
        fontWeight: 600,
        textAlign: 'center',
        marginTop: 4,
        color: '#555',
    },
    packageStats: {
        display: 'flex',
        flex: 1,
        justifyContent: 'space-around',
    },
    packageStat: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    packageStatLabel: {
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: 0.8,
        color: palette.primary.main,
        textTransform: 'uppercase',
        marginBottom: 2,
    },
    packageStatValue: {
        fontSize: 16,
        fontWeight: 700,
    },
    packageStatRate: {},
    addressCard: {
        backgroundColor: '#fff',
        border: `1px solid ${palette.primary.light}`,
        borderRadius: 8,
        padding: '10px 14px',
        height: '100%',
        boxSizing: 'border-box',
    },
    addressCardLabel: {
        color: palette.primary.main,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 1,
        textTransform: 'uppercase',
        marginBottom: 4,
    },
    addressCardName: {
        fontSize: 15,
        fontWeight: 700,
        lineHeight: 1.4,
    },
    addressCardValue: {
        fontSize: 13,
        color: '#555',
        lineHeight: 1.4,
        marginTop: 2,
    },
    cardTitleRow: {
        display: 'flex',
        alignItems: 'center',
    },
    cardTitleIcon: {
        marginRight: '8px',
    }
};
  
export default styles;